import React, { useState } from 'react'
import DownloadTable from './downloadTable'
import DownloadTabsHeader from '../DownloadTabsHeader'
import DownloadsTabsContent from '../DownloadsTabsContent'

function DownloadTab(props) {
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  return (
    <div>
      <DownloadTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => props.setSelectedOption(option)}
        onSearch={onSearch}
        keyTab={props.keyTab}
        lowStock={props.lowStock}
        setLowStock={value => props.setLowStock(value)}
      />
      <DownloadsTabsContent keyTab={props.keyTab} component={DownloadTable} selectedOption={props.selectedOption} searchText={searchText} lowStock={props.lowStock} />
    </div>
  )
}

export default DownloadTab

DownloadTab.defaultProps = {
  edit: {},
  shopsList: [],
}
